(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-quantity-selector"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function readState(key) {
      try { var raw = localStorage.getItem(key); return raw ? JSON.parse(raw) : null; }
      catch (e) { return null; }
    }
    function writeState(key, value) {
      try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
    }
    function randomBetween(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }
    function freshState(min, max) { return { startedAt: Date.now(), initial: randomBetween(min, max) }; }
    function setupStock(banner) {
      if (banner.__bqsStockInit) return;
      banner.__bqsStockInit = true;
      var minStart    = parseInt(banner.dataset.minStart, 10);
      var maxStart    = parseInt(banner.dataset.maxStart, 10);
      var floor       = parseInt(banner.dataset.floor, 10);
      var intervalMin = parseInt(banner.dataset.intervalMin, 10);
      var resetHours  = parseInt(banner.dataset.resetHours, 10);
      var key         = banner.dataset.storageKey;
      var countEl     = banner.querySelector('[data-stock-count]');
      function compute() {
        var now = Date.now();
        var state = readState(key);
        var expired = state && (now - state.startedAt) > resetHours * 3600 * 1000;
        var invalid = state && (typeof state.initial !== 'number' || state.initial < minStart || state.initial > maxStart);
        if (!state || expired || invalid) {
          state = freshState(minStart, maxStart);
          writeState(key, state);
        }
        var elapsedMin = (now - state.startedAt) / 60000;
        var decrements = Math.floor(elapsedMin / intervalMin);
        var count = state.initial - decrements;
        if (count < floor) {
          state = freshState(minStart, maxStart);
          writeState(key, state);
          count = state.initial;
        }
        return count;
      }
      function render() {
        if (!countEl) return;
        var next = compute();
        var current = parseInt(countEl.textContent, 10);
        if (current !== next) {
          countEl.classList.add('is-ticking');
          countEl.textContent = next;
          setTimeout(function () { countEl.classList.remove('is-ticking'); }, 260);
        }
      }
      render();
      setInterval(render, 60000);
    }

    function refreshCartSections() {
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:change'));
      } catch (e) {}
    }

    function swapSections(sections) {
      if (!sections) return;
      var parser = new DOMParser();
      ['cart-drawer', 'cart-icon-bubble'].forEach(function (id) {
        if (!sections[id]) return;
        var newDoc = parser.parseFromString(sections[id], 'text/html');
        var selector = id === 'cart-drawer' ? 'cart-drawer' : '#cart-icon-bubble';
        var newEl = newDoc.querySelector(selector);
        var oldEl = document.querySelector(selector);
        if (newEl && oldEl) oldEl.innerHTML = newEl.innerHTML;
      });
    }

    function openCartDrawer() {
      var notif = document.querySelector('cart-notification');
      if (notif && typeof notif.open === 'function') { notif.open(); return true; }
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        if (typeof drawer.open === 'function') { drawer.open(); return true; }
        drawer.classList.add('active', 'is-open', 'open');
        document.documentElement.classList.add('cart-drawer-open');
        return true;
      }
      var triggers = [
        '[data-cart-drawer-trigger]',
        '[data-action="open-drawer"][data-drawer="cart"]',
        '.js-drawer-open-cart',
        '.site-header__cart-toggle',
        '#CartDrawer-trigger',
        '[aria-controls="CartDrawer"]',
        '#cart-icon-bubble'
      ];
      for (var i = 0; i < triggers.length; i++) {
        var el = document.querySelector(triggers[i]);
        if (el) { el.click(); return true; }
      }
      if (window.theme && typeof window.theme.openCartDrawer === 'function') { window.theme.openCartDrawer(); return true; }
      if (window.Shopify && window.Shopify.theme && typeof window.Shopify.theme.openCartDrawer === 'function') { window.Shopify.theme.openCartDrawer(); return true; }
      if (typeof window.openCart === 'function') { window.openCart(); return true; }
      return false;
    }

    function setupBundle(root) {
      if (root.__bqsInit) return;
      root.__bqsInit = true;

      var form        = root.querySelector('[data-bundle-form]');
      var radios      = root.querySelectorAll('[data-bundle-radio]');
      var cta         = root.querySelector('[data-bundle-cta]');
      var ctaLabel    = root.querySelector('[data-cta-label]');
      var errorEl     = root.querySelector('[data-bundle-error]');
      var successEl   = root.querySelector('[data-bundle-success]');
      var openDrawer  = root.dataset.openDrawer === 'true';
      var idInput     = form.querySelector('[data-variant-id]');
      var defaultCta  = ctaLabel ? ctaLabel.textContent : '';

      var variantsScript = root.querySelector('[data-bundle-variants-json]');
      var variants = [];
      if (variantsScript) {
        try { variants = JSON.parse(variantsScript.textContent); } catch (e) {}
      }

      function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; successEl.hidden = true; }
      function hideError() { errorEl.hidden = true; }
      function showSuccess(msg) { successEl.textContent = msg; successEl.hidden = false; }
      function hideSuccess() { successEl.hidden = true; }

      function getSelectedOptions() {
        var inputs = root.querySelectorAll('[data-option-input]:checked');
        var options = [];
        inputs.forEach(function (input) {
          var pos = parseInt(input.dataset.optionPosition, 10);
          options[pos - 1] = input.value;
        });
        return options;
      }

      function findMatchingVariant() {
        if (!variants.length) return null;
        var selected = getSelectedOptions();
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
      }

      function updateVariant() {
        var variant = findMatchingVariant();
        if (!variant) return;
        idInput.value = variant.id;
        if (!variant.available) {
          cta.disabled = true;
          if (ctaLabel) ctaLabel.textContent = 'Sold out';
          showError('This option is sold out.');
        } else {
          cta.disabled = false;
          if (ctaLabel) ctaLabel.textContent = defaultCta;
          hideError();
        }
      }

      function updateBundleSelection() {
        radios.forEach(function (r) {
          var card = r.closest('.bqs-card');
          if (card) card.classList.toggle('is-selected', r.checked);
        });
        hideError();
        hideSuccess();
        if (variants.length) updateVariant();
      }

      root.querySelectorAll('[data-option-input]').forEach(function (input) {
        input.addEventListener('change', updateVariant);
      });
      radios.forEach(function (r) { r.addEventListener('change', updateBundleSelection); });

      if (variants.length) updateVariant();
      updateBundleSelection();

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        hideError();
        hideSuccess();

        if (!idInput.value) {
          showError('No variant selected.');
          return;
        }
        var checked = root.querySelector('[data-bundle-radio]:checked');
        if (!checked || !checked.value) {
          showError('Please choose a bundle to continue.');
          return;
        }

        cta.classList.add('is-loading');
        cta.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: idInput.value,
            quantity: parseInt(checked.value, 10),
            sections: 'cart-drawer,cart-icon-bubble'
          })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) {
                throw new Error((data && (data.description || data.message)) || 'Could not add to cart.');
              }
              return data;
            });
          })
          .then(function (data) {
            swapSections(data.sections);
            refreshCartSections();

            if (openDrawer) {
              setTimeout(function () {
                var opened = openCartDrawer();
                if (!opened) showSuccess('Added to cart. Check your cart icon to view it.');
                cta.classList.remove('is-loading');
                cta.disabled = false;
              }, 150);
            } else {
              showSuccess('Added to cart.');
              cta.classList.remove('is-loading');
              cta.disabled = false;
            }
          })
          .catch(function (err) {
            cta.classList.remove('is-loading');
            cta.disabled = false;
            showError(err.message || 'Something went wrong. Please try again.');
          });
      });
    }

    function initAll(scope) {
      var root = scope || document;
      root.querySelectorAll('[data-bundle-stock]').forEach(setupStock);
      root.querySelectorAll('[data-bundle-section]').forEach(setupBundle);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
